export default {
    Account: {
        application_addresses: 'My Addresses',
        application_invoice_info: 'My Invoice Info',
        application_orders: 'My Orders',
    },
    AddressClosest: {
        info_sheet_title: 'There is a closer address available!',
        info_sheet_description:
            'There is an address named {{address}} that is closer to your current location. Would you like to use this address?',
        info_sheet_accept_button: 'Use Nearest Address',
        info_sheet_reject_button: 'Continue With Current Address',
        alert_error_title: 'Oh No!',
        alert_error_message:
            'Unfortunately, the Merchant does not serve the selected address',
        alert_error_action_button: 'Choose Another Address',
        alert_error_action_reject_button: 'Cancel',
    },
    AddressCreate: {
        route_header_title: 'Add New Address',
        route_header_description:
            'You can add or edit addresses to access product lists.',
        success_toast_message: 'Address added successfully',
        check_box_title: 'Set as my default address',
        form_label_address_title: 'Address Title',
        form_label_street: 'Street',
        form_label_building_number: 'Building No',
        form_label_floor: 'Floor',
        form_label_door_number: 'Apartment No',
        form_label_directions: 'Directions',
        form_placeholder_first_name: 'First Name',
        form_placeholder_last_name: 'Last Name',
        form_placeholder_phone: 'Mobile Phone',
        row_title_contact_information: 'CONTACT INFORMATION',
        dropdown_field_label: 'City, District, Neighborhood',
        dropdown_field_city_modal_header_title: 'Select City',
        dropdown_field_city_description:
            'Select city, district and neighborhood for the address',
        dropdown_field_district_modal_header_title: 'Select District',
        dropdown_field_neighborhoods_modal_header_title: 'Select Neighborhood',
        submit_button: 'Save',
        alert_error_title: 'Oh No!',
        alert_error_message:
            'Unfortunately, the Merchant does not serve the selected address',
        alert_error_action_button: 'Choose Another Address',
        alert_error_action_reject_button: 'Cancel',
    },
    AddressUpdate: {
        route_header_title: 'Update Address',
        route_header_description: 'Update your address information here.',
        success_toast_message: 'Address updated successfully',
        submit_button: 'Save',
    },
    Addresses: {
        right_info_title: 'How Do My Addresses Work?',
        right_info_description:
            'In the My Addresses section, you can save delivery addresses for your "Delivery to Address" orders. You can give a name to your addresses to identify them more easily. When adding an address, you can enter details such as city, district, neighborhood, street address, building number, door number, and floor. You can set one of your added addresses as the default address, delete existing addresses, or add new addresses. You can save a maximum of 10 addresses in the system.',
        address_list_section_title: 'My Registered Addresses',
        address_list_section_bar_title: 'My Addresses',
        address_list_section_bar_description:
            'You can add or delete addresses to access the product list',
    },
    AddressMap: {
        route_header_title: 'Select Your Address on the Map',
        route_header_description:
            'Quickly and accurately add your address by selecting your location on the map.',
        submit_location_button: 'Use This Location',
        search_field_placeholder: 'Search for neighborhood, street, or avenue',
    },
    AddressList: {
        success_toast_message: 'Address information successfully deleted',
        alert_delete_address_title: 'Address Deletion Process',
        alert_delete_address_message:
            'Are you sure you want to delete the selected address?',
        alert_delete_action_button: 'Delete Address',
        alert_delete_action_cancel_button: 'Cancel',
        list_empty_component_title: 'No Address Found',
        list_empty_component_description:
            'Your registered address will be listed here when you have one',
        address_list_footer_button: 'Add New Address',
        toast_provider_error_message: 'Maximum address limit reached',
        address_edit_chip_label: 'Edit',
        address_action_sheet_title: 'Edit Address',
        address_action_sheet_message:
            'Choose one of the options below to manage this address.',
        address_action_update_button: 'Update Address Information',
    },
    InvoiceInfos: {
        section_bar_title: 'Billing Information',
        section_title: 'My Saved Invoice Info',
        section_bar_description:
            'You can create, select, and update your billing information.',
        right_info_title: 'How Does My Invoice Info Work?',
        right_info_description:
            'In the My Invoice Info section, you can save individual or corporate billing details to be used when issuing invoices. Each entry can have a title, contact information, tax details, and an address. You can mark one entry as the default, delete existing ones, or add new entries.',
        list_empty_component_title: 'No Invoice Info Found',
        list_empty_component_description:
            'Your saved invoice info will appear here when you add one',
        list_footer_button: 'Add New Invoice Info',
        edit_chip_label: 'Edit',
        toast_provider_error_message: 'Maximum invoice info limit reached',
    },
    InvoiceInfoActions: {
        action_sheet_title: 'Edit Invoice Info',
        action_sheet_message:
            'Choose one of the options below to manage this invoice info.',
        action_update_button: 'Update Invoice Information',
        alert_delete_title: 'Invoice Info Deletion',
        alert_delete_message:
            'Are you sure you want to delete the selected invoice info?',
        alert_delete_action_button: 'Delete Invoice Info',
        alert_delete_action_cancel_button: 'Cancel',
        delete_success_toast_message: 'Invoice info successfully deleted',
    },
    InvoiceInfoCreate: {
        route_header_title: 'Add New Billing Info',
        route_header_description:
            'Add the individual or corporate billing details to be used when issuing invoices.',
        success_toast_message: 'Billing info successfully added',
        check_box_title: 'Set as default invoice.',
        row_title_contact_information: 'CONTACT & BILLING INFORMATION',
        customer_personal_label: 'Personal',
        customer_corporate_label: 'Corporate',
        form_label_title: 'Billing Title',
        form_label_street: 'Street',
        form_label_building_number: 'Building No',
        form_label_floor: 'Floor',
        form_label_door_number: 'Door No',
        form_placeholder_title: 'Enter a title',
        form_placeholder_first_name: 'First Name',
        form_placeholder_last_name: 'Last Name',
        form_placeholder_phone: 'Phone Number',
        form_placeholder_email: 'Email',
        form_placeholder_id_number: 'National ID',
        form_placeholder_company_name: 'Company Name',
        form_placeholder_tax_number: 'Tax Number',
        form_placeholder_tax_office: 'Tax Office',
        submit_button: 'Save',
    },
    InvoiceInfoUpdate: {
        route_header_title: 'Edit Billing Info',
        route_header_description: 'Update your invoice info here.',
        success_toast_message: 'Billing info successfully updated',
        submit_button: 'Save',
    },
    Invoices: {
        content_header_title: 'Invoices',
        content_header_description:
            'You can easily access all invoice movements here.',
        search_placeholder: 'Search',
        empty_sheet_title: 'No Invoices',
        empty_sheet_description: 'No specific invoices were found for you.',
    },
    InvoiceDetail: {
        route_header_title: 'Invoice',
        pdf_toast_error_message: 'An error occurred while loading the PDF',
        error_title: 'Error',
        error_description:
            'Your invoice cannot be downloaded at the moment. Please try again later or contact customer service.',
    },
    InvoicesFilter: {
        route_header_title: 'Invoice Filter',
        content_description:
            'Apply the necessary filters and easily access the results',
        form_wallet_select_label: 'Wallet Selection',
        form_wallet_select_placeholder: 'Select Wallet',
        form_final_total_from_label: 'Minimum Amount',
        form_final_total_to_label: 'Maximum Amount',
        form_start_date_label: 'Start Date',
        form_end_date_label: 'End Date',
        submit: 'Show Results',
    },
    UserFallback: {
        passive_title: 'Your Account Is Inactive',
        passive_description:
            'Your account has been deactivated, so you cannot view your wallet details.',
        blacklisted_title: 'Account Access Restricted',
        blacklisted_description:
            'Your account has been restricted within the scope of security controls, you can contact support.',
    },
}
